<style lang="scss">
$--accent: rgb(255, 234, 0);
$--shadow: 2.7px 5.3px 20px 0 rgba(0, 0, 0, 0.1);
$--transition: all .25s ease-in-out;

.user {
  &__box {
    // padding: 20px 0;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;

    min-width: 240px;
    max-width: 240px;
    width: 240px;

    border-radius: 10px;
    // box-shadow: $--shadow;
    background-color: rgb(255, 255, 255);
  }
  &__avatar {
    margin: 50px 0 18px 24px;
    display: flex;
    flex-direction: row;
    justify-content: stretch;
    align-items: stretch;

    > picture {
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: flex-end;
      overflow: hidden;
      background-color: $--accent;

      border-radius: 50%;

      min-width: 64px;
      max-width: 64px;
      width: 64px;

      min-height: 64px;
      max-height: 64px;
      height: 64px;
      > img {
        width: 52px;
      }
    }
  }
  &__menu {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    width: 100%;
    &__item {
      text-decoration: none;
      color: rgb(136, 136, 136);
      cursor: pointer;
      user-select: none;

      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
      width: 100%;
      transition: $--transition;

      font-family: Inter;
      font-size: 14px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.29;
      letter-spacing: normal;

      min-height: 30px;
      max-height: 30px;
      height: 30px;
      margin: 10px 0;

      &:hover, &.router-link-active {
        // font-weight: 500;
        color: rgb(0, 0, 0);
      }
      &:hover &__anchor, &.router-link-active &__anchor {
        background-color: $--accent;
      }
      &__anchor { // anchor
        transition: $--transition;
        width: 4px;
        height: 30px;
        background-color: transparent;
        margin-right: 20px;
      }
      &__text { // text
        flex: 1;
      }
      &__counter { // counter
        font-family: Inter;
        font-size: 13px;
        font-weight: 600;
        font-stretch: normal;
        font-style: normal;
        letter-spacing: normal;
        text-align: right;
        margin-right: 30px;
        &.points {
          margin-right: 22px;
          padding: 8px;
          border-radius: 8px;
          color: rgb(130, 0, 255);
          border: solid 1px rgb(130, 0, 255);
          // background-color: rgb(130, 0, 255);
        }
      }
    }
  }
}
</style>

<template lang="pug">
aside
  .user__box
    .user__avatar(v-if="!isArena", :class=`{
      'has-sub': profile && profile.hasSubscribe && profile.hasSubscribe === 1,
    }`)
      picture
        img(src="@/assets/svg/user-avatar.svg", alt="")
    .user__arena(style="margin: 3rem 0 3rem 1rem;", v-if="isArena", :class=`{
      'has-sub': profile && profile.hasSubscribe && profile.hasSubscribe === 1,
    }`)
      a(href="https://minskarena.by")
        img.inversion(src="@/assets/img/arena_logo.png", alt="")
    .user__menu(v-if="!isArena")
      router-link.user__menu__item(to="/tickets/actual")
        span.user__menu__item__anchor
        span.user__menu__item__text {{ $t('common.myOrders') }}
        //- span.user__menu__item__counter {{ profile ? profile.actualOrdersCount : '' }}

      router-link.user__menu__item(to="/profile")
        span.user__menu__item__anchor
        span.user__menu__item__text {{ $t('common.myProfile') }}

      router-link.user__menu__item(to="/balance")
        span.user__menu__item__anchor
        span.user__menu__item__text {{ $t('common.myPoints') }}
        span.user__menu__item__counter.points {{ profile ? profile.balance : '' }}

      router-link.user__menu__item(to="/cards")
        span.user__menu__item__anchor
        span.user__menu__item__text {{ $t('common.myCards') }}

      //- router-link.user__menu__item(to="/promotions")
        span.user__menu__item__anchor
        span.user__menu__item__text {{ $t('common.promos') }}

      //- router-link.user__menu__item(to="/videos")
        span.user__menu__item__anchor
        span.user__menu__item__text {{ $t('common.myVideos') }}

      //- router-link.user__menu__item(to="/early-booking")
        span.user__menu__item__anchor
        span.user__menu__item__text {{ $t('aside.abonements') }}

      //- router-link.user__menu__item(to="/subscribes")
        span.user__menu__item__anchor
        span.user__menu__item__text {{ $t('aside.subscribes') }}

      //- router-link.user__menu__item(to="/help")
        span.user__menu__item__anchor
        span.user__menu__item__text {{ $t('common.help') }}

      .user__menu__item(@click="$root.logout()")
        //- router-link.user__menu__item(to="/logout")
        span.user__menu__item__anchor
        span.user__menu__item__text {{ $t('logout') }}

      //- example link
      //- router-link.user__menu__item(to="")
        span.user__menu__item__anchor
        span.user__menu__item__text
        span.user__menu__item__counter

</template>

<script>
export default {
  props: ['profile'],
  data: () => ({
    isArena: false,
    isAfishaDomain: true,
  }),
  mounted() {
    if (window.location.href.match(/minskarena/)) this.isArena = true;
    if (window.location.href.match(/localhost/) || window.location.href.match(/guru.ge/)) this.isAfishaDomain = false;
  },
};
</script>

<style lang="scss">
.inversion {
  filter: invert(1);
}
.user__avatar.has-sub {
  position: relative;
  &:after {
    position: absolute;
    z-index: 0;
    top: 50%;
    left: 50%;
    width: 78px;
    height: 78px;
    margin: -39px 0 0 -39px;
    content: '';
    background: url('../assets/img/sub.svg') center center no-repeat;
    background-size: contain;
  }
}
</style>
